import DocTypesForContractFiltering from '../../component/documentDownload/raiseDownloadRequest/DocTypesForContractFiltering.json';
import Smartlook from '../../utils/smartlook';

import {
  Option,
  SearchAutocomplete,
  Select,
  Typography,
} from '@deere/fuel-react';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './AssetSearchOption.css';

const AssetSearchOption = (props) => {
  const {t} = useTranslation();
  const [selectedAssetFilter, setSelectedAssetFilter] =
    React.useState('serialNumber');
  const [selectedAssetInfo, setSelectedAssetInfo] = React.useState(null);
  const [dataList, setDataList] = React.useState([]);

  const getDataList = () => {
    const data = [];

    if (
      props.docType &&
      props.docType !== 'LIEN_DE_REGISTRATION_LETTERS' &&
      props.contracts
    ) {
      for (const contract of props.contracts) {
        const productLine = contract.productLine;
        if (
          props.country &&
          DocTypesForContractFiltering[props.country][productLine]?.includes(
            props.docType
          )
        ) {
          const assets =
            props.contractDetails?.[contract.contractNumber].assets;
          if (assets) {
            for (const asset of assets) {
              if (asset[selectedAssetFilter]) {
                data.push({
                  label: asset[selectedAssetFilter],
                  value: contract.contractNumber,
                });
              }
            }
          }
        }
      }
    } else if (
      props.docType &&
      props.docType == 'LIEN_DE_REGISTRATION_LETTERS' &&
      props.pastContracts
    ) {
      for (const contract of props.pastContracts) {
        const productLine = contract.productLine;
        if (
          props.country &&
          DocTypesForContractFiltering[props.country][productLine]?.includes(
            props.docType
          )
        ) {
          const assets = props.assetDetails?.[contract.contractNumber]?.assets;
          if (assets) {
            for (const asset of assets) {
              if (asset[selectedAssetFilter]) {
                data.push({
                  label: asset[selectedAssetFilter],
                  value: contract.contractNumber,
                });
              }
            }
          }
        }
      }
    } else {
      for (let contractNo in props.contractDetails) {
        props.contractDetails[contractNo].assets
          .filter((asset) => asset[selectedAssetFilter])
          .map((assset, index) => {
            data.push({
              label: assset[selectedAssetFilter],
              value: contractNo,
            });
          });
      }
    }
    setDataList(data);
  };

  const searchClickHandler = (e, newValue) => {
    setSelectedAssetInfo(newValue ? newValue.label : null);
    if (newValue !== null) {
      props.setAssetContractOption(newValue.value);
    }
  };

  const AssetsSearchFilterHandler = (e) => {
    setSelectedAssetFilter(e.target.value);
    setSelectedAssetInfo(null);
  };

  React.useEffect(() => {
    Smartlook.navigation('AssetSearchOption');
  }, []);

  React.useEffect(() => {
    getDataList();
  }, [selectedAssetFilter, props.docType]);

  return (
    <div className="assetSearchOptionContainer">
      <Typography gutterBottom variant="h5" required={true}>
        {props.searchTitle || t('SEARCH_OPTION_LABEL')}{' '}
      </Typography>
      <div className="asset-search-option">
        <Select
          id="AssetsSearchFilter"
          name="AssetsSearchFilter"
          label={t('SELECT_SERVICE_REQUEST_TYPE')}
          defaultValue={selectedAssetFilter}
          className={'selectedAssetFilter'}
          onChange={AssetsSearchFilterHandler}
        >
          <Option value="serialNumber">{t('SERIAL_NUMBER')}</Option>
          <Option value="registrationNumber">{t('REGISTRATION_NUMBER')}</Option>
        </Select>
        <SearchAutocomplete
          className="asset-search-option-TextField"
          options={dataList}
          InputProps={{
            placeholder: t('SEARCH_OPTION_PLACEHOLDER'),
            id: 'searchOptionTextField',
          }}
          onChange={searchClickHandler}
          size="small"
          defaultValue={selectedAssetInfo}
          value={selectedAssetInfo}
          isOptionEqualToValue={(option, value) => option.label == value}
        ></SearchAutocomplete>
      </div>
    </div>
  );
};

AssetSearchOption.propTypes = {
  docType: PropTypes.string,
  contracts: PropTypes.array,
  pastContracts: PropTypes.array,
  contractDetails: PropTypes.object,
  assetDetails: PropTypes.object,
  country: PropTypes.string,
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    contracts: state.appStates.contractNumbers?.contracts,
    pastContracts: state.appStates.contractNumbers?.pastContracts,
    contractDetails: state.appStates.contractDetails?.accountDetails,
    assetDetails: state.appStates.lienDeregistrationData,
  };
};
export default connect(mapStateToProps)(AssetSearchOption);
